var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        title: _vm.$t("message.areyousuretodeletethis"),
        hideFooter: "",
        noCloseOnBackdrop: "",
        noCloseOnEsc: "",
        hideHeaderClose: "",
        noFade: ""
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-end",
          staticStyle: { gap: "10px" }
        },
        [
          !_vm.loading
            ? [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    attrs: { type: "button" },
                    on: { click: _vm.onCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "button" },
                    on: { click: _vm.onSubmit }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.delete")))]
                )
              ]
            : [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light",
                    attrs: { type: "button", disabled: "" }
                  },
                  [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "button", disabled: "" }
                  },
                  [_c("i", { staticClass: "fas fa-spinner spin" })]
                )
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7bc575e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7bc575e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseConfirmDeleteModal.vue
// module id = null
// module chunks = 